import {updateMyTeamsFilter} from '/redux/action/myTeams.action';

import {getDefaultFilters} from '../util/myTeamsFilterDomain.util';

import {useMyTeamsContext} from './useMyTeamsContext';

export const useClearMyTeamsFilters = () => {
  const {dispatch} = useMyTeamsContext();

  return (defaultNewCoachesKey: string, frontlineOnlyOverride?: boolean) => {
    const defaultFilters = getDefaultFilters(defaultNewCoachesKey);

    dispatch(
      updateMyTeamsFilter({
        ...defaultFilters,
        frontlineOnly: frontlineOnlyOverride ?? defaultFilters.frontlineOnly,
      }),
    );
  };
};
